<div class="ziro-report-content">
  <ziro-text fieldId="reportName"></ziro-text>
  <ziro-select fieldId="cucmServer"></ziro-select>
  <ziro-code-area fieldId="sqlQuery"></ziro-code-area>
  <div class="row">
    <div class="col-lg-9 offset-lg-3">
      <span>{{ 'tkey;reports.custom_reports.sql_field.helptext_1' | translate }}</span>
      <button
        type="button"
        class="btn btn-border btn-link ps-1 pe-1 test-query-link text-decoration-none"
        (click)="testQueryClicked()"
        data-automation="cucm-report-test-query-link-button"
      >
        {{ 'tkey;reports.custom_reports.sql_field.helptext_2' | translate }}
      </button>
      <span>{{ 'tkey;reports.custom_reports.sql_field.helptext_3' | translate }}</span>
    </div>
  </div>

  @if (!isTableLoading && hasQueryRun) {
    <legend id="query-results-header">
      {{ 'tkey;menu.report.cucm_report_builder.query_results.title' | translate }}
    </legend>
  }

  @if (isTestQueryClicked && (isTableLoading || !hasQueryRun)) {
    <ziro-loading-block></ziro-loading-block>
  }

  @if (!isTableLoading && hasQueryRun) {
    <ziro-datatable
      [class]="'ziro-card'"
      [isCondensed]="true"
      [dataAutomation]="tableDataAutomation"
      [minTableHeight]="'20rem'"
      [noResultsAlert]="'tkey;menu.report.cucm_report_builder.no_results'"
      [columns]="columns"
      [rowDataSource]="tableData"
      [uniqueRowIdentifier]="null"
    ></ziro-datatable>
  }
</div>
